import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./index.scss";
import bgImage from "../../../assets/images/bg-reseau.jpg";
import NewslettreService from "../../../services/newsletter/newslettre.service";
import { showSuccessToaster } from "../../toaster/success";
import { showErrorToaster } from "../../toaster/error";

const newslettreService = new NewslettreService();

const ReseauSection = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [emailError, setEmailError] = useState("");

  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setEmailError(t("reseau.errorRequired"));
      showErrorToaster(t("reseau.errorRequired"));
    } else if (!isValidEmail(email)) {
      setEmailError(t("reseau.errorInvalid"));
      showErrorToaster(t("reseau.errorInvalid"));
    } else {
      try {
        const data = { email };
        await newslettreService.addNewslettre(data);
        showSuccessToaster(t("reseau.success"));
        setEmail("");
        setEmailError("");
      } catch (error) {
        showErrorToaster(
          error.response
            ? error.response.data.message
            : t("reseau.errorGeneric")
        );
      }
    }
  };

  return (
    <section
      className="reseau-section"
      style={{ backgroundImage: `url(${bgImage})` }}>
      <div className="overlay"></div>

      <Row className="align-items-center">
        <Col lg={7} md={8}>
          <div className="reseau-content">
            <h2>{t("reseau.title")}</h2>

            <Form
              className="reseau-form d-flex mt-4 flex-column"
              onSubmit={handleSubmit}>
              <Form.Control
                type="email"
                placeholder={t("reseau.placeholder")}
                className="email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
              />
              <Button
                type="submit"
                className="submit-btn mt-3"
                disabled={loading}>
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  t("reseau.button")
                )}
              </Button>
            </Form>

            {message.text && (
              <Alert
                variant={message.type}
                className="mt-3 text-center"
                style={{ borderRadius: "10px" }}>
                {message.text}
              </Alert>
            )}
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default ReseauSection;
